<sticky-free [stickyId]="'product-view-details'"
             [stickyOffset]="'page-header-wrapper'"
             [stickyOff]="client.isCms || !!parentView?.productView?.showExternal"
             [order]="1">
    <div class="w-12 bg-col-w p-l-8 p-r-8 p-b-6 pos-relative">
        <product-view-name [product]="product"
                           [parentView]="parentView"
                           [parent]="parent"
                           [content]="content"
                           [showKlarna]="parentView.showKlarna" />

        @if (parent.isConfigurable) {
        <product-configurable-options [product]="product"
                                      [parentView]="parentView"
                                      [preselectOptions]="['color']"
                                      [preselectSingles]="true"
                                      [excludeOptions]="['size']"
                                      [sizeGuideVariant]="parentView.sizeGuideVariant"
                                      [storage]="true"
                                      (init)="parentView.handleInitChange($event.data)"
                                      (selectionChange)="parentView.handleSelectionChange($event.data)"
                                      (sizeGuideClicked)="parentView.openSidebar('size-guide')"
                                      (dataChange)="parentView.handleDataChange($event.data)" />
        }

        @if (parent.isBundle) {
        <product-bundle-options [product]="product"
                                [selection]="parentView.productView.bundleSelection"
                                [buyRequest]="parentView.request" />
        }

        <!-- size options -->
        @if (parent.isConfigurable) {
        <product-configurable-options-size [product]="product"
                                           [parentView]="parentView"
                                           [preselectOptions]="['color']"
                                           [preselectSingles]="true"
                                           [storage]="true"
                                           [sizeGuideVariant]="parentView.sizeGuideVariant"
                                           (init)="parentView.handleInitChange($event.data)"
                                           (selectionChange)="parentView.handleSelectionChange($event.data)"
                                           (sizeGuideClicked)="parentView.openSidebar('size-guide')"
                                           (dataChange)="parentView.handleDataChange($event.data)" />
        }

        <!-- delivery messages -->
        <product-delivery-messages [backorderDeliveryTime]="product.backorderDeliveryTime"
                                   [deliveryFlag]="product.deliveryFlag" />

        <!-- gift box -->
        @if (product.hasGiftBox) {
        <product-gift-box [source]="product"
                          (giftBoxSelectionChange)="giftBoxSelectionChangeHandle($event)" />
        }

        @if (product.isOutOfStock && !parent.isConfigurable) {
        <button class="w-12 button is-out-of-stock"
                (click)="openXnotifEmail()">
            <span class="flex flex-middle flex-justify-center">
                <span class="flex flex-middle right m-l-2 m-l-4-s"
                      [sizeClass]="'M: no-wrap'">{{'Email me when back in stock' | translate}}</span>
                <i class="icon-email fs-9 m-t-1"></i>
            </span>
        </button>
        } @else {
        <add-to-basket class="block"
                       [class.m-t]="product.hasGiftBox"
                       [product]="product"
                       [parentView]="parentView"
                       [buyRequest]="parentView.request"
                       [basketRequest]="getBasketRequest()"
                       [selection]="parentView.configurableSelection"
                       [changeText]="true" />
        }

        @if (product.data?.category_ids?.includes(757)) {
        <icms-outlet-block [name]="'Straps Upsell Carousel Block'"
                           [variant]="'straps-upsell-carousel'"
                           [allowOnly]="['basket-straps-upsell-carousel']" />
        }

        @if (parentView.showCountdownBanner && !client.isS) {
        <countdown-banner />
        }

        <p class="p-t-3 p-b-6 center p4"
           *iCms="'delivery_info' of content; content: 'html'; skipEmpty: true">
        </p>

        <!-- general information  -->
        <product-view-summary class="p-t-2-x p-t-2-l"
                              [product]="product"
                              [parentView]="parentView"
                              [parent]="parent"
                              [content]="content" />

        <!-- share button XML -->
        <product-view-share [product]="product" />

        <breadcrumbs class="block m-t-2" />
    </div>
</sticky-free>